<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <!-- <div style="z-index: 1; position: absolute; top: 0px; left: 0px; bottom: 0px; right: 0px; ">
      <img
        src="/assets/loginBg.jpg"
        style=" background-position: center; top: 0px; left: 0px; bottom: 0px; right: 0px; height:100%;width:100% "
      />
    </div>-->
    <div style="position: relative">
      <div style="position: absolute; left: 2rem; top: 1.5rem; z-index: 999">
        <img
          src="/assets/loginlogoblue.png"
          class="img-fluid"
          width="50%"
          height="50%"
          alt="logo"
        />
      </div>
      <div v-if="showForgotDiv == false">
        <div class="my-login-page formcard">
          <section class="h-100">
            <!-- <div class="container h-100"> -->
            <div
              class="row align-items-center main-login-page"
              style="height: 100vh; background-color: #fff"
            >
              <div class="col-lg-8 bg-img" style="padding: 0">
                <img
                  src="/assets/dashboard-bg-img.png"
                  class="img-fluid"
                  width="100%"
                  alt="image"
                  style="height: 100vh !important"
                />
              </div>
              <div class="col-lg-4 login-card">
                <div class="brand">
                  <!-- <img src="dist/img/brand/icon.png"> -->
                  <!-- style="
                      width: 400px;
                      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                        0 6px 20px 0 rgba(0, 0, 0, 0.19);
                    "
                    class="card fat formCard" -->
                </div>

                <div>
                  <div class="card-body auth-form-light text-left" style="padding: 4rem">
                    <h3 style="color: #5e5873; margin-bottom: 1rem">
                      Welcome to Pridel! 👋
                    </h3>
                    <h5
                      style="font-size: 1rem; 
                        line-height: 1.5rem;
                        color: #6e6b7b
                        margin-bottom: 1.5rem;"
                    >
                      Please sign-in to your account and start the adventure
                    </h5>

                    <!-- <h5 class="card-title mainClick">Account Login</h5> -->
                    <form action="/">
                      <div class="form-group">
                        <label style="color: #5e5873; font-size: 0.857rem" for="email"
                          >Username</label
                        >
                        <b-input-group>
                          <!-- <b-input-group-prepend is-text>
                              <md-icon icon="envelope">person</md-icon>
                            </b-input-group-prepend>-->
                          <b-form-input
                            class="input-box"
                            style="text-transform: none !important"
                            type="text"
                            v-model="payload.email"
                            placeholder="Enter Username"
                          ></b-form-input>
                        </b-input-group>
                      </div>
                      <div class="form-group">
                        <label style="color: #5e5873; font-size: 0.857rem" for="password"
                          >Password</label
                        >

                        <b-input-group>
                          <!-- <b-input-group-prepend is-text>
                               <md-icon icon="envelope">no_encryption</md-icon> 
                            </b-input-group-prepend>-->
                          <b-form-input
                            class="input-box"
                            style="text-transform: none !important"
                            type="password"
                            required
                            placeholder="Enter Password"
                            v-model="payload.password"
                          ></b-form-input>
                        </b-input-group>
                      </div>
                      <div class="form-group">
                        <a
                          style="
                            font-size: 0.857rem;
                            font-weight: 400;
                            color: #525584;
                            margin-top: -10px !important;
                          "
                          class="pull-right showMoreData"
                          @click="openForgotDiv"
                          for="checkbox1"
                          >Forgot Password?</a
                        >
                      </div>
                      <div class="form-group mt-4">
                        <b-button
                          class="btn-primary btn-block mt-3"
                          style="text-transform: none; padding: 0.375rem 0.75rem"
                          variant="primary"
                          @click="loginNew"
                          >Sign in</b-button
                        >
                      </div>
                      <div class="margin-top20 text-center"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </section>
        </div>
      </div>

      <!-- Forgot Div -->
      <div class="container2" v-else>
        <div v-if="showResetModal == false">
          <div class="my-login-page formcard">
            <section class="h-100">
              <!-- <div class="container h-100"> -->
              <div
                class="row align-items-center main-login-page"
                style="height: 100vh; background-color: #fff"
              >
                <div class="col-lg-8 bg-img" style="padding: 0">
                  <img
                    src="/assets/forgotpage-img.PNG"
                    class="img-fluid"
                    width="100%"
                    alt="image"
                    style="height: 100vh !important"
                  />
                </div>
                <div class="col-lg-4 login-card">
                  <div class="brand">
                    <!-- <img src="dist/img/brand/icon.png"> -->
                  </div>

                  <div>
                    <div
                      class="card-body auth-form-light text-left"
                      style="padding: 4rem"
                    >
                      <h5 style="color: #5e5873; margin-bottom: 1rem">
                        Forgot Password? 🔒
                      </h5>
                      <p
                        style="
                          font-size: 0.9rem;
                          line-height: 1.5rem;
                          color: #6e6b7b;
                          font-weight: 400;
                          margin-bottom: calc(1rem - 10px);
                        "
                      >
                        Enter your email and we'll send you instructions to reset your
                        password
                      </p>
                      <!-- <span
                          class="font-weight-light text-muted"
                        >Please enter your username ..!</span>-->
                      <!-- <h5 class="card-title mainClick">Account Login</h5> -->
                      <form action="/">
                        <div class="form-group">
                          <label style="color: #5e5873; font-size: 0.857rem" for="email"
                            >Username</label
                          >
                          <b-input-group>
                            <b-form-input
                              style="text-transform: none !important"
                              type="text"
                              :required="true"
                              placeholder="Enter Username"
                              v-model="forgotModel.emailForgot"
                              ref="email"
                            >
                            </b-form-input>

                            <span class="error" v-if="!forgotModel.emailForgot">{{
                              emailForgotError
                            }}</span>
                          </b-input-group>
                        </div>

                        <div class="form-group mt-4">
                          <!-- @click="sendForgotPassword" -->
                          <b-button
                            class="pull-left btn-primary btn-block mt-3"
                            variant="primary"
                            style="text-transform: none; padding: 0.375rem 0.75rem"
                            @click="getData"
                            required
                            >Recover Password</b-button
                          >
                        </div>
                        <div class="form-group mt-4">
                          <b-button
                            variant="light"
                            class="pull-right btn-block"
                            style="border: 1px solid #52548314; text-transform: none"
                            @click="backToLogin"
                            >Back To Login</b-button
                          >
                        </div>
                        <div class="margin-top20 text-center"></div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </div> -->
            </section>
          </div>
        </div>
        <div v-else>
          <div class="my-login-page formcard">
            <section class="h-100">
              <div class="container h-100">
                <div class="row justify-content-md-center">
                  <div class="col-md-7 col-lg-5">
                    <div class="brand">
                      <!-- <img src="dist/img/brand/icon.png"> -->
                    </div>

                    <div
                      style="
                        width: 400px;
                        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
                          0 6px 20px 0 rgba(0, 0, 0, 0.19);
                      "
                      class="card fat formCard"
                    >
                      <div class="card-body auth-form-light text-left p-5">
                        <h5 class="font-weight-light">Please Enter New password...!</h5>
                        <span class="font-weight-light text-muted">
                          Note : OTP has been Sent to Registered Email Address
                        </span>

                        <!-- <h5 class="card-title mainClick">Account Login</h5> -->
                        <form action="/">
                          <div class="form-group">
                            <label style="color: #000" for="email">New Password</label>
                            <b-input-group>
                              <b-form-input
                                style="text-transform: none !important"
                                type="text"
                                :required="true"
                                placeholder="Enter Password"
                                v-model="PasswordModal.newPassword"
                                @keyup="samePassword"
                                ref="email"
                              ></b-form-input>
                            </b-input-group>
                            <span
                              class="error"
                              v-if="PasswordModal.passNotMatchErr != ''"
                              >{{ passNotMatchErr }}</span
                            >
                            <span
                              class="error"
                              v-if="PasswordModal.passLessThanError != ''"
                              >{{ passLessThanError }}</span
                            >
                          </div>

                          <div class="form-group">
                            <label style="color: #000" for="email"
                              >Confirm Password</label
                            >
                            <b-input-group>
                              <b-form-input
                                style="text-transform: none !important"
                                type="text"
                                :required="true"
                                placeholder="Re-Enter Password"
                                v-model="PasswordModal.confPassword"
                                @keyup="samePassword"
                                ref="email"
                              ></b-form-input>
                            </b-input-group>
                            <span
                              class="error"
                              v-if="PasswordModal.passNotMatchErr != ''"
                              >{{ passNotMatchErr }}</span
                            >
                            <span
                              class="error"
                              v-if="PasswordModal.passLessThanError != ''"
                              >{{ passLessThanError }}</span
                            >
                          </div>

                          <div class="form-group">
                            <label style="color: #000" for="email"
                              >OTP (Sent on registered email)</label
                            >
                            <b-input-group>
                              <b-form-input
                                style="text-transform: none !important"
                                type="text"
                                :required="true"
                                @keyup="samePassword"
                                placeholder="Enter OTP"
                                v-model="PasswordModal.emailOTP"
                                ref="email"
                              ></b-form-input>
                            </b-input-group>
                            <span
                              class="error"
                              v-if="PasswordModal.emailOTPError != ''"
                              >{{ emailOTPError }}</span
                            >
                          </div>

                          <div class="form-group mt-4">
                            <b-button
                              variant="primary"
                              class="pull-left"
                              @click="updatePassword"
                              >Reset Password
                            </b-button>
                            <b-button
                              variant="light"
                              class="pull-right"
                              @click="backToLogin"
                              >Back To Login</b-button
                            >
                          </div>
                          <div class="margin-top20 text-center"></div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>

    <md-dialog-confirm
      ref="confirm_dailog"
      :md-title="error.title"
      :md-content-html="error.message"
      :md-ok-text="error.okText"
      :md-cancel-text="error.cancelText"
      @open="onOpen"
      @close="onClose"
    ></md-dialog-confirm>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopInvalidEmail"
    ></md-dialog-alert>
    <div class="toast-nit" v-if="showtoast">
      <p>{{ toastmsg }}</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import LoginServices from "../../../services/LoginServices";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  beforeMount() {
    // location.reload();
    // alert(this.$route.query.is_mobile)
    // console.log("localStorage PS=>", localStorage.getItem("loginId"));
    if (
      localStorage.getItem("loginId") != undefined &&
      localStorage.getItem("loginId") != "" &&
      localStorage.getItem("loginId") != null
    ) {
      this.$router.push({
        path: "/dashboard",
      });
    }
    sessionStorage.setItem("loginStatus", "true");
    this.$store.dispatch("setCurrentRoute", "/login");
    this.$store.dispatch("setSidebarMargin", 0);
    // this.doLoading();
    //this.getData();
    // console.log(localStorage.getItem("loginId"));
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$router.push({
        path: "/dashboard",
      });
    } else {
    }
  },
  mounted() {
    // if (this.$auth.redirect()) {
    //   this.redirect = this.$auth.redirect().from.name;
    // }
  },
  beforeDestroy() {},
  destroyed() {},

  data() {
    return {
      toastmsg: "",
      showtoast: false,
      passNotMatchErr: "",
      emailOTPError: "",
      passLessThanError: "",
      PasswordModal: {
        newPassword: "",
        confPassword: "",
        emailOTP: "",
        userId: "",
      },
      userOTP: "",
      emailForgotError: "",
      validUserPass: "",
      validName: "",
      USERID: "",
      validUserEmail: "",
      inputEmail: [],
      validUserName: "",
      showForgotDiv: false,
      showResetModal: false,
      forgotModel: {
        emailForgot: "",
      },
      alert: {
        content: "Correct",
        ok: "ok",
      },
      isLoading: false,
      userDetails: ["abc"],
      payload: {
        email: "",
        password: "",
        rememberMe: false,

        redirect: "",
      },
      error: {
        title: "Something went wrong",
        message: "All fields are required. Fill in all details before login",
        okText: "OK",
        cancelText: "CANCEL",
      },
    };
  },
  components: {
    // Loading
    CustomLoader,
  },
  computed: {},
  methods: {
    updatePassword() {
      this.isLoading = true;
      if (this.PasswordModal.emailOTP == "") {
        this.alert.content = "Please Enter OTP sent on  Registered Email ";
        this.$refs["addPopInvalidEmail"].open();
        return false;
      }
      if (this.PasswordModal.emailOTP != "") {
        if (this.userOTP != this.PasswordModal.emailOTP) {
          this.emailOTPError = "Invalid OTP ";
        } else {
          this.emailOTPError = "";
        }
      } else {
        this.emailOTPError = "";
      }
      if (this.PasswordModal.newPassword != this.PasswordModal.confPassword) {
        this.passNotMatchErr = "Passwords do not match ";
      } else {
        this.passNotMatchErr = "";
      }

      if (
        this.PasswordModal.newPassword == this.PasswordModal.confPassword &&
        this.PasswordModal.newPassword.length <= 4
      ) {
        this.passLessThanError = "Password length should be 5 character atleast";
        return false;
      } else {
        this.passLessThanError = "";
      }
      this.PasswordModal["userId"] = this.USERID;

      let options = {
        method: "POST",
        url: `${URL_BASE}/resetForgotPasswordfromLogin.php`,
        data: JSON.stringify(this.PasswordModal),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            this.PasswordModal.newPassword = "";
            this.PasswordModal.confPassword = "";
            this.PasswordModal.emailOTP = "";
            this.isLoading = false;
            if (data.msg == "Updated") {
              this.alert.content = "Password Updated";
              this.$refs["addPop1"].open();
            } else {
              this.alert.content = "Some Error occurred..!!";
              this.$refs["addPop1"].open();
            }

            this.showForgotDiv = false;
            this.showResetModal = false;
          }
        })
        .catch((error) => {});
    },
    samePassword() {
      if (this.PasswordModal.newPassword != this.PasswordModal.confPassword) {
        this.passNotMatchErr = "Passwords do not match ";
      } else {
        this.passNotMatchErr = "";
      }

      if (
        this.PasswordModal.newPassword == this.PasswordModal.confPassword &&
        this.PasswordModal.newPassword.length <= 4
      ) {
        this.passLessThanError = "Password length should be 5 character atleast";
        return false;
      } else {
        this.passLessThanError = "";
      }
      if (this.PasswordModal.emailOTP != "") {
        if (this.userOTP != this.PasswordModal.emailOTP) {
          this.emailOTPError = "Invalid OTP ";
        } else {
          this.emailOTPError = "";
        }
      } else {
        this.emailOTPError = "";
      }
    },

    sendForgotPassword() {
      this.isLoading = true;
      let new_data = {
        validUserName: this.validUserName,
        validPass: this.validUserPass,
        validName: this.validName,
        userId: this.USERID,
        validEmail: this.validUserEmail,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/sendForgotPassword.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.status_code == 1) {
              this.userOTP = data.OTP;
              this.showResetModal = true;
              this.isLoading = false;
            }
          }
        })
        .catch((error) => {});
    },
    getData() {
      if (this.forgotModel.emailForgot == "") {
        this.toastmsg = "Please Enter Username !";
        this.showtoast = true;
        setTimeout(() => {
          this.toastmsg = "Please Enter Username !";
          this.showtoast = false;
        }, 2000);
        //this.alert.content = "Please Enter Username";
        //this.$refs["addPopInvalidEmail"].open();
        //return false;
      }
      let new_data = {
        forgortPass: "1",
        userId: this.USERID,
        userName: this.forgotModel.emailForgot,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getDataForgotLogin.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.singleUserDetails.length > 0) {
              this.validUserName = data.singleUserDetails[0].username;
              this.validUserEmail = data.singleUserDetails[0].email;
              this.validUserPass = data.singleUserDetails[0].password;
              this.validName = data.singleUserDetails[0].employeeName;
              this.USERID = data.singleUserDetails[0].userId;

              this.sendForgotPassword();
            } else {
              this.alert.content = "Invalid Username";
              this.$refs["addPopInvalidEmail"].open();
            }
          }
        })
        .catch((error) => {});
    },
    openForgotDiv() {
      this.showForgotDiv = true;
    },
    backToLogin() {
      this.showForgotDiv = false;
    },

    openDialog() {
      this.$refs.confirm_dailog.open();
    },
    closeDialog() {
      this.$refs.confirm_dailog.close();
    },
    onOpen() {},
    onClose(type) {
      if (this.alert.content != "Invalid Credential") {
        this.$router.push({
          path: "/dashboard",
        });
      }
    },
    // onClose1(type) {
    //   this.$router.push({
    //     path: "/login"
    //   });
    // },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
        this.$router.push({
          path: "/dashboard",
        });
      }, 1200);
    },
    // login() {
    //   const { email, password, rememberMe  , redirect } = this.payload;
    //
    //   const _redirect =
    //     redirect != null && redirect != "" ? redirect : "/dashboard";
    //   if (email && password && password.length > 2) {
    //     this.$store.dispatch("setIsProgressVisible", true);
    //     this.$auth.login({
    //       headers: {
    //         "Content-Type": "application/json"
    //       },
    //       data: {
    //         email,
    //         password
    //       },
    //       rememberMe: rememberMe,
    //       redirect: _redirect,
    //       success(res) {
    //         this.$store.dispatch("setIsProgressVisible", false);
    //       },
    //       error(error) {
    //         this.$store.dispatch("setIsProgressVisible", false);
    //       }
    //     });
    //   } else {
    //     this.openDialog();
    //   }
    // },
    loginNew_Bak() {
      let data1 = {
        UserName: this.payload.email || "",
        PasswordMod: this.payload.password || "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/login.php`,
        data: JSON.stringify(data1),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      axios(options)
        .then((result) => {
          if (result.data.Id != "" && result.data.Id != undefined) {
            // console.log("result.data: ", result.data);
            localStorage.setItem("loginId", result.data.Id);
            localStorage.setItem("loginType", result.data.type);
            localStorage.setItem("userPermission", "");
            localStorage.setItem("cust_username", result.data.cust_username);
            localStorage.setItem("branch_baseLocation", result.data.branch_baseLocation);
            localStorage.setItem("fcl_job_pendency", result.data.fcl_job_pendency);
            localStorage.setItem("add_console_booking_pre", result.data.add_console_booking_pre);
            localStorage.setItem("user_view_page_pref", result.data.user_view_page_pref);
            localStorage.setItem("con_job_pendency", result.data.con_job_pendency);
            localStorage.setItem("cc_exp_job_pendency", result.data.cc_exp_job_pendency);
            localStorage.setItem("cc_imp_job_pendency", result.data.cc_imp_job_pendency);
            localStorage.setItem("ff_imp_job_pendency", result.data.ff_imp_job_pendency);
            localStorage.setItem("branchclientPre", result.data.branchclientPre);
            localStorage.setItem("user_pre", result.data.user_pre);
            localStorage.setItem("transportTypePre", result.data.transportTypePre);
            localStorage.setItem("nameUser", result.data.userName);
            localStorage.setItem("designation", result.data.designation);
            localStorage.setItem("userLevel", result.data.userLevel);
            localStorage.setItem("employeeCode", result.data.employeeCode);
            localStorage.setItem("employeeName", result.data.employeeName);
            localStorage.setItem("userId", result.data.userId);
            localStorage.setItem("portLoginAccess", result.data.portLoginAccess);
            localStorage.setItem("is_access_multi_update", result.data.is_access_multi_update);
            localStorage.setItem(
              "is_Mobile",
              this.$route.query.is_mobile ? this.$route.query.is_mobile : "No"
            );

            localStorage.setItem("departmentName", result.data.departmentName);
            localStorage.setItem("finalPagePermision", result.data.finalPagePermision);
            this.$sessionsStorage.set("loginId", result.data.Id);
            this.$sessionsStorage.set("loginType", result.data.type);
            this.$sessionsStorage.set("userPermission", "");
            this.$sessionsStorage.set("cust_username", result.data.cust_username);
            this.$sessionsStorage.set("branch_baseLocation", result.data.branch_baseLocation);
            this.$sessionsStorage.set("fcl_job_pendency", result.data.fcl_job_pendency);
            this.$sessionsStorage.set("add_console_booking_pre", result.data.add_console_booking_pre);
            this.$sessionsStorage.set("user_view_page_pref", result.data.user_view_page_pref);
            this.$sessionsStorage.set("con_job_pendency", result.data.con_job_pendency);
            this.$sessionsStorage.set("cc_exp_job_pendency", result.data.cc_exp_job_pendency);
            this.$sessionsStorage.set("cc_imp_job_pendency", result.data.cc_imp_job_pendency);
            this.$sessionsStorage.set("ff_imp_job_pendency", result.data.ff_imp_job_pendency);
            this.$sessionsStorage.set("branchclientPre", result.data.branchclientPre);
            this.$sessionsStorage.set("user_pre", result.data.user_pre);
            this.$sessionsStorage.set("transportTypePre", result.data.transportTypePre);
            this.$sessionsStorage.set("nameUser", result.data.userName);
            this.$sessionsStorage.set("designation", result.data.designation);
            this.$sessionsStorage.set("userLevel", result.data.userLevel);
            this.$sessionsStorage.set("employeeCode", result.data.employeeCode);
            this.$sessionsStorage.set("employeeName", result.data.employeeName);
            this.$sessionsStorage.set("userId", result.data.userId);
            this.$sessionsStorage.set("portLoginAccess", result.data.portLoginAccess);
            this.$sessionsStorage.set("is_access_multi_update", result.data.is_access_multi_update);
            this.$sessionsStorage.set(
              "is_Mobile",
              this.$route.query.is_mobile ? this.$route.query.is_mobile : "No"
            );

            this.$sessionsStorage.set("departmentName", result.data.departmentName);
            this.$sessionsStorage.set(
              "finalPagePermision",
              result.data.finalPagePermision
            );
            // console.log("Happy Singh=>", result.data);
            this.$store.dispatch("setUserEmail", result.data.userName);
            this.$store.dispatch("setUserDepartment", result.data.departmentName);
            this.$store.dispatch("setPagePermision", result.data.finalPagePermision);

            this.$store.dispatch("setUserDesignation", result.data.designation);

            this.alert.content = "Login Successfully";
            if (this.$route.query.is_mobile == "yes") {
              this.$router.push({
                path: "/lead/leadlist",
              });
            } else if (
              this.$route.query.is_mobile == "port" &&
              result.data.portLoginAccess == 1
            ) {
              this.$router.push({
                path: "/viewAllModuleDetails/viewAllModuleDetails",
              });
            }

            // this.$refs["addPop"].open();
            this.doLoading();
          } else {
            self;
            this.toastmsg = "Invalid Credential !";
            this.showtoast = true;
            setTimeout(() => {
              this.showtoast = false;
            }, 1500);

            // this.alert.content = "Invalid Credential";
            // this.$refs["addPop"].open();
          }
        })
        .catch((error) => {});
    },
    async loginNew() {
      let data1 = {
        UserName: this.payload.email || "",
        PasswordMod: this.payload.password || "",
      };

      let resp = await LoginServices.Login(data1);

      if (resp.Id != "" && resp.Id != undefined) {
        localStorage.setItem("loginId", resp.Id);
        localStorage.setItem("loginType", resp.type);
        localStorage.setItem("userPermission", "");
        localStorage.setItem("cust_username", resp.cust_username);
        localStorage.setItem("branch_baseLocation", resp.branch_baseLocation);
        localStorage.setItem("fcl_job_pendency", resp.fcl_job_pendency);
        localStorage.setItem("add_console_booking_pre", resp.add_console_booking_pre);
        localStorage.setItem("user_view_page_pref", resp.user_view_page_pref);
        localStorage.setItem("con_job_pendency", resp.con_job_pendency);
        localStorage.setItem("cc_exp_job_pendency", resp.cc_exp_job_pendency);
        localStorage.setItem("cc_imp_job_pendency", resp.cc_imp_job_pendency);
        localStorage.setItem("ff_imp_job_pendency", resp.ff_imp_job_pendency);
        localStorage.setItem("branchclientPre", resp.branchclientPre);
        localStorage.setItem("user_pre", resp.user_pre);
        localStorage.setItem("transportTypePre", resp.transportTypePre);
        localStorage.setItem("nameUser", resp.userName);
        localStorage.setItem("designation", resp.designation);
        localStorage.setItem("userLevel", resp.userLevel);
        localStorage.setItem("employeeCode", resp.employeeCode);
        localStorage.setItem("employeeName", resp.employeeName);
        localStorage.setItem("userId", resp.userId);
        localStorage.setItem("portLoginAccess", resp.portLoginAccess);
        localStorage.setItem("is_access_multi_update", resp.is_access_multi_update);
        localStorage.setItem(
          "is_Mobile",
          this.$route.query.is_mobile ? this.$route.query.is_mobile : "No"
        );

        localStorage.setItem("departmentName", resp.departmentName);
        localStorage.setItem("finalPagePermision", resp.finalPagePermision);
        this.$sessionsStorage.set("loginId", resp.Id);
        this.$sessionsStorage.set("loginType", resp.type);
        this.$sessionsStorage.set("userPermission", "");
        this.$sessionsStorage.set("cust_username", resp.cust_username);
        this.$sessionsStorage.set("branch_baseLocation", resp.branch_baseLocation);
        this.$sessionsStorage.set("fcl_job_pendency", resp.fcl_job_pendency);
        this.$sessionsStorage.set("add_console_booking_pre", resp.add_console_booking_pre);
        this.$sessionsStorage.set("user_view_page_pref", resp.user_view_page_pref);
        this.$sessionsStorage.set("con_job_pendency", resp.con_job_pendency);
        this.$sessionsStorage.set("cc_exp_job_pendency", resp.cc_exp_job_pendency);
        this.$sessionsStorage.set("cc_imp_job_pendency", resp.cc_imp_job_pendency);
        this.$sessionsStorage.set("ff_imp_job_pendency", resp.ff_imp_job_pendency);
        this.$sessionsStorage.set("branchclientPre", resp.branchclientPre);
        this.$sessionsStorage.set("user_pre", resp.user_pre);
        this.$sessionsStorage.set("transportTypePre", resp.transportTypePre);
        this.$sessionsStorage.set("nameUser", resp.userName);
        this.$sessionsStorage.set("designation", resp.designation);
        this.$sessionsStorage.set("userLevel", resp.userLevel);
        this.$sessionsStorage.set("employeeCode", resp.employeeCode);
        this.$sessionsStorage.set("employeeName", resp.employeeName);
        this.$sessionsStorage.set("userId", resp.userId);
        this.$sessionsStorage.set("portLoginAccess", resp.portLoginAccess);
        this.$sessionsStorage.set("is_access_multi_update", resp.is_access_multi_update);
        this.$sessionsStorage.set(
          "is_Mobile",
          this.$route.query.is_mobile ? this.$route.query.is_mobile : "No"
        );

        this.$sessionsStorage.set("departmentName", resp.departmentName);
        this.$sessionsStorage.set("finalPagePermision", resp.finalPagePermision);
        this.$store.dispatch("setUserEmail", resp.userName);
        this.$store.dispatch("setUserDepartment", resp.departmentName);
        this.$store.dispatch("setPagePermision", resp.finalPagePermision);

        this.$store.dispatch("setUserDesignation", resp.designation);

        this.alert.content = "Login Successfully";
        if (this.$route.query.is_mobile == "yes") {
          this.$router.push({
            path: "/lead/leadlist",
          });
        } else if (this.$route.query.is_mobile == "port" && resp.portLoginAccess == 1) {
          this.$router.push({
            path: "/viewAllModuleDetails/viewAllModuleDetails",
          });
        }
        this.doLoading();
      } else {
        self;
        this.toastmsg = "Invalid Credential !";
        this.showtoast = true;
        setTimeout(() => {
          this.showtoast = false;
        }, 1500);
      }
    },
  },
};
</script>

<style scoped>
.toast-nit {
  position: fixed;
  top: 10px;
  right: 10px;
  width: 30%;
  color: #e91212;
  background-color: #e7b5b5a1;
  padding: 0.5rem;
  border-radius: 5px;
}
.toast-nit p {
  margin: 0%;
  font-size: 1rem;
}
.input-box {
  padding: 0.438rem 1rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  height: auto !important;
}
.btn-primary {
  border: none;
}
.md-theme-default a:not(.md-button):hover {
  color: #e91212cc !important;
}

.btn-primary:hover {
  box-shadow: 0 8px 25px -8px #000449ad;
  background-color: #000449ad;
}
.input-group > .form-control:not(:last-child) {
  border-radius: 4px !important;
}
.login-card {
  background-color: #ffffff;
  padding: 0;
}
.form-control {
  border-radius: 4px !important;
}
.form-control:focus {
  border-color: #002b49;
  box-shadow: none;
}

@media (max-width: 992px) {
  .bg-img {
    display: none !important;
  }
  .login-card {
    width: 500px;
  }
  .main-login-page {
    justify-content: center;
  }
}
@media only screen and (max-width: 500px) {
  #container2 {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// login.vue?0c92f53a